import type { CompRef } from 'types/documentServices';
import { MigrationStepError } from '../../utils';
import constants from '#packages/constants';

import type { EditorAPI } from '#packages/editorAPI';

const isSection = (editorAPI: EditorAPI, compRef: CompRef) =>
  editorAPI.components.getType(compRef) === constants.COMP_TYPES.SECTION;

export const ensureEveryPageHasSections = async (
  editorAPI: EditorAPI,
  pagesRefs: CompRef[],
) => {
  const everyPageHasSectionChild = pagesRefs.every((pageRef) =>
    editorAPI.components
      .getChildren(pageRef)
      .some((childRef) => isSection(editorAPI, childRef)),
  );

  if (!everyPageHasSectionChild) {
    throw new MigrationStepError(
      'Migration failed: not every page has a section child',
    );
  }
};

export const ensureOnlySectionsInRoot = async (
  editorAPI: EditorAPI,
  pagesRef: CompRef[],
) => {
  const everyRootCompIsSection = pagesRef.every((pageRef) =>
    editorAPI.components.getChildren(pageRef).every(
      (childRef) =>
        isSection(editorAPI, childRef) ||
        // skip pinned components as they are should not be inside sections
        editorAPI.components.layout.isPinned(childRef),
    ),
  );

  if (!everyRootCompIsSection) {
    throw new MigrationStepError(
      'Migration failed: page has non-section child in the root',
    );
  }
};
